import React, { useContext, useEffect, useState } from 'react';
import GoBack from '../../globalComponents/GoBack';
import { Button, Card, Checkbox, List, Radio, Space } from 'antd';
import { FaUser } from 'react-icons/fa6';
import { LiaBackspaceSolid } from 'react-icons/lia';
import { GiPayMoney } from 'react-icons/gi';
import EventEmitter from '../../utils/eventEmitter';
import { useLoaderData, useNavigate } from 'react-router-dom';
import { MdClose } from 'react-icons/md';
import PosSessionContext from '../utils/PosSessionContext';
import usePosOrderAPI from '../apis/posOrderAPI';
import { errorModal, warning } from '../modals/ModalMessages';
import formatAmount from '../../utils/formatAmount';


// const paymentMethods = [
//   {value: 'cash', label: 'Cash'},
//   {value: 'bank', label: 'Bank'},
//   {value: 'momo', label: 'Momo'}
// ]

const gridStyle = {
  width: '25%',
  height: '70px',
  padding: '0px',
  
};


const PosMakPayment = () => {
  const { paymentMethods } = useLoaderData();
  const navigate = useNavigate();
  const { state, dispatch, order, tax } = useContext(PosSessionContext);
  const [myOrder, setOrder] = useState(order);
  const [payments, setPayments] = useState([]);
  const [orderTotal, setOrderTotal] = useState(0);
  const [paymentTotal, setPaymentTotal] = useState(0);
  const [deliveryType, setDeliveryType] = useState(order.picking_state);
  const [demandSold, setDemandSold] = useState(order.picking_state === 'demand_sold' ? true : false);
  const { create } = usePosOrderAPI();
  const [isLoading, setIsLoading] = useState(false);

  // console.log(tax)
  const onChangeDeliveryType = e => setDeliveryType(e.target.value);
  const onChangeDemandSold = e => setDemandSold(e.target.checked);

  useEffect(() => {
    let total = myOrder.orderlines.reduce((prev, current) => ((current.subtotal*1 + current.tax*1) + prev), 0);
    // console.log(total, myOrder.orderlines[0].subtotal*1)
    setOrderTotal(total);
    let paymentTotal_ = payments.reduce((prev, current) => (((current.amount * 1) + prev * 1) * 1), 0);
    setPaymentTotal(paymentTotal_);
  },[payments])

  // useEffect(() => {
  //   window.document.addEventListener('keydown', e => handleKeyboardInput(e));

  //   return () => {
  //     window.document.removeEventListener('keydown', e => handleKeyboardInput(e));
  //   }
  // },[]);

  const onChange = (method) => {
    let payments_ = [...payments];
    let obj = {...method};
    let total = orderTotal;
    let selectedPaymentTotal = payments_.reduce((prev, current) => (((current.amount * 1) + prev * 1) * 1), 0);

    let findPayMethod = payments_.find(payment => payment.id === obj.id);
    if (findPayMethod === undefined) {
      // if (order._is_refund || Math.sign(total) === -1) {
      //   if (selectedPaymentTotal >= total) {
      //     obj['amount'] = (total + selectedPaymentTotal) < 0 ? (total + selectedPaymentTotal) : 0;
      //   }else {
      //     obj.amount = 0;
      //   }
      // }
      if (selectedPaymentTotal >= total) {
        // obj['amount'] = 0;
      }else {
        obj['amount'] = (total - selectedPaymentTotal) > 0 ? (total - selectedPaymentTotal) : 0;
      }
      
      obj.select = true;
      payments_.forEach((_, id) => {
        if (payments_.length !== id) {
          payments_[id].select = false;
        }
      });
      
      payments_.push(obj);
      setPayments(payments_);

    }else {
      // if (order._is_refund || Math.sign(total) === -1) {
      //   if (selectedPaymentTotal >= total) {
      //     obj['amount'] = (total + selectedPaymentTotal) < 0 ? (total + selectedPaymentTotal) : 0;
      //   }else {
      //     obj.amount = 0;
      //   }
      // }
      if (selectedPaymentTotal >= total) {
        obj['amount'] = 0;
      }else {
        obj['amount'] = (total - selectedPaymentTotal) > 0 ? (total - selectedPaymentTotal) : 0;
      }
      obj.select = true;
      payments_.forEach((_, id) => {
        if (payments_.length !== id) {
          payments_[id].select = false;
        }
      })
      payments_.push(obj);
      setPayments(payments_);
    }
    
  }

  const onSelect = (payment) => {
    let payments_ = [...payments];
    if (!payment.select) {
      let foundSelected = payments_.findIndex(method => method.select === true);
      // console.log(foundSelected);
      payments_[foundSelected].select = false;
      let found = payments_.findIndex(method => (method.id === payment.id && method.select === false));
      payments_[found].select = true;
      setPayments(payments_);
    }
  }

  const removePayment = (id, e) => {
    e.preventDefault();
    let payments_ = [...payments];
    payments_.splice(id, 1);
    if (payments_.length > 0) payments_[payments_.length - 1].select = true;
    setPayments(payments_);
  }
  // console.log(typeof(payments[0]?.amount))
  const add = (number) => {
    let items_ = [...payments];
    // if (order._is_refund || Math.sign(orderTotal) === -1) {
    //   number = String(number * -1);
    // }

    // let total = myOrder.orderlines.reduce((prev, current) => (((current.sales_price * (current.quantity*1).toFixed(2)) + prev * 1) * 1).toFixed(2), 0) * 1;
    let found = items_.findIndex(payment => payment.select === true);
    if (found >= 0) {
      
      if (items_[found].amount === orderTotal) items_[found].amount = '';
      var currentPaymentAmount = items_[found].amount;
      let amount = '0';
      if (number.length > 1) {
        amount = String(currentPaymentAmount * 1 + (number * 1));
      }else {
        amount = String(currentPaymentAmount + number );
      }

      // checks quantity is string
      if (typeof(amount) === 'string') {
        let amount_ = amount.split('.');
        if (amount_.length === 2) {
          let amountQuantity = amount_[1];
          if (amountQuantity.length > 3) return;
          if (amountQuantity.length === 3) {
            let amountQuantity_ = parseFloat(amountQuantity * 1);
            amount_[1] = amountQuantity_;
            let newAmount = amount_.join('.');
            items_[found].amount = newAmount;
            // const order = await this.update({event: this.#event, cart: items_});
            this.setItems(order);
            return;
          };
        }
        items_[found].amount = amount;
        // const order = await this.update({event: this.#event, cart: items_});
        // this.setItems(items_);
        setPayments(items_);
      }else{
        if (typeof(quantity) === 'number') {

          // const order = await this.update({event: this.#event, cart: items_});
          // this.setItems(items_);
          setPayments(items_);
        }
      }
    };
  }

  const remove = () => {
    let carts_ = [...payments];
    if (carts_.length > 0) {
      let cart = carts_.findIndex(cart => cart.select === true); // find cart item this is selected
      
      // Checks whether quantity is integer
      if (typeof(carts_[cart].amount) === 'number') {
        // checks quantity as number then zero it
        if (carts_[cart].amount > 0) {
          carts_[cart].amount = 0;
          // this.setItems(carts_);
          // const order = await this.update({event: this.#event, cart: carts_});
          // this.setItems(order);
          setPayments(carts_);
        }else {
          if (carts_.length === 1) {
            carts_[0].select = true;
            carts_.pop();
          }else {
            carts_.splice(cart, 1);
            carts_[carts_.length - 1].select = true;
          }
          // const order = await this.update({event: this.#event, cart: carts_});
          // this.setItems(order);
          // this.setItems(carts_);
          setPayments(carts_);
        }
      }else { // quantity is string
  
        let amount = carts_[cart].amount.split('');
        // removes each quantity element
        amount.pop(); 

        // quantity array one convert to number       
        if (amount.length === 1) {
          carts_[cart].amount = amount[0]*1;
        }else {
          // convert quantity array to string number
          let amount_ = amount.join('');
          carts_[cart].amount = amount_;
        }
        // const order = await this.update({event: this.#event, cart: carts_});
          // this.setItems(order);
        // this.setItems(carts_);
        setPayments(carts_)
      }
    }
  }
  // console.log(order)
  const validatePayment = async() => {
    try {
      setIsLoading(true);
      let order_ = {...myOrder};
      if (paymentTotal >= orderTotal) {
        order_['paymentLines'] = [...payments];
        order_['totalAmount'] = orderTotal;
        order_['totalPaid'] = orderTotal;
        order_['status'] = 'paid';
        if (deliveryType === 'delivered') order_.picking_state = deliveryType 
        else if (deliveryType === 'pick_later') order_.picking_state = deliveryType
        // else if (deliveryType === 'pick_demand_later') order_.picking_state = deliveryType;
        if (order.picking_state === 'pick_later') {
          order_.demand_sold = demandSold;
          // order_.is_demand_sold = 
        }
        let order_change = 0;
        if ((paymentTotal - orderTotal) > 0) {
          let fakePaymentLines = [...order_.paymentLines]; 
          let cash = order_.paymentLines.filter(line => line.name.toLowerCase().includes('cash'));
          order_change = formatAmount(paymentTotal - orderTotal) * 1;

          if (cash.length > 1) {
            let cashSummed = cash.reduce((prev, current) => (current.amount*1 + prev*1), 0);
            let realCash = cashSummed*1 - order_change *1;
            let distributionCash = realCash / cash.length;
            order_.paymentLines.forEach((line, idx) => {
              if (line.name.toLowerCase().includes('cash')) {
                order_.paymentLines[idx].amount = formatAmount(distributionCash)*1;
              }
            });
          }else {
            let realCash = cash[0].amount - order_change*1;
            order_.paymentLines.forEach((line, idx) => {
              if (line.name.toLowerCase().includes('cash')) {
                order_.paymentLines[idx].amount = formatAmount(realCash)*1;
              }
            });
          }
        }
        order_.session_id = state.session_id;
        order_.pos_id = state.pos_id;
        // order_.employee_id = state.employee_id;
        
        
        const codes = await create(order_);
        // console.log(codes)
        order_.receipt_number = codes.receipt_no;
        order_.order_ref = codes.order_no;
        order_.order_change = order_change;
        // console.log(order_)
        // console.log(order)
        dispatch({event: 'MAKE_PAYMENT', item: order_});
        setIsLoading(false);
        navigate('/pos/session/order/payment-sucess');
      }else { 
        errorModal(
          'PAYMENT VALIDATION FAILED!',
          <div className='text-gray-600'>
            <p>Payment received is less than the total order amount to be paid for.</p>
            <p>Please check, and try again!</p>
          </div>
        );
      setIsLoading(false);
      }
    }catch (err) {
      if (err.response?.status === 307) {
        errorModal(
          'SESSION CLOSED!', 
          <div>
            <p>This session is currently closed.</p>
            <p>Please start a new session to start selling.</p>
          </div>
        )
      }
      setIsLoading(false);
    }
  }

  const handleKeyboardInput = (event) => {
    const key = event.key;

    // Check if the key is a number (0-9) or decimal point (.)
    if (/[0-9]/.test(key)) {
      add(String(key));
      // console.log(key)
    }

    // Check for Enter key to trigger calculation
    // else if (key === "Enter") {
    //   // handleOk();
    //   console.log('enter pressed');
    // }
    // Check for backspace key to clear the last character (delete)
    else if (key === "Backspace") {
      remove();
      // console.log('backspace pressed');
    }
    // Check for Escape key to clear the display
    // else if (key === "Escape") {
    //   // resetPasscode();
    //     console.log('esc pressed');
    // }
  };



  return (
    <div onKeyDown={handleKeyboardInput} className='container mx-auto' id='mk-pymt' style={{maxWidth: '1200px'}}>
      <div className='shadow payment-page' >
        <div className='bg-white flex items-center payment-header' >
          <div className='flex items-center'><GoBack /> <span>Back</span></div>
          <span className='text-center w-full font-bold text-gray-600'>Make Payment</span>
        </div>
        <div className='flex justify-between payment-body'>
          <div className='payment-left-pane bg-white w-2/5 border-8'>
            <h3 className='ps-3 font-semibold text-xl' style={{height: '7%'}}>Payment Methods</h3>
            <div className='flex flex-col justify-between border-y-2' style={{height: '93%'}}>
              <div className=''>
                {paymentMethods.map(method => 
                  <div className='' key={method.id} onClick={()=> onChange(method)}>
                    <Button type='text' className='h-full text-start p-3 font-semibold w-full rounded-none'>
                      {method.name}
                    </Button>
                  </div>
                )}
              </div>
              <div>
                {payments.map((method, idx) => 
                    <div key={idx} className={method.select ? 'btn-selected hover:cursor-pointer text-white font-semibold w-full rounded-none' : 'hover:cursor-pointer font-semibold w-full rounded-none'} onClick={()=> onSelect(method)}>
                      <div className='flex justify-between p-2'>
                        <span>{method.name}</span>
                        <div className='flex items-center w-2/5 justify-between'>
                          <span>{formatAmount(order.is_refund ? method.amount * -1 : method.amount * 1)}</span>
                          <MdClose onClick={(e) => removePayment(idx, e)} className='hover:bg-red-500'/>
                        </div>
                      </div>
                    </div>
                  )}
              </div>
              <div className='bg-[#05bcc4] h-2/5'>
                <Button type='text' loading={isLoading} disabled={order.status === 'paid' ? true : false} onClick={validatePayment} className='font-semibold w-full h-full flex flex-col items-center justify-center rounded-none'>
                  <GiPayMoney size={'4rem'}/>
                  <span style={{height: '26px', color: 'white'}}>Validate</span>
                </Button>
              </div>
            </div>
          </div>
          <div className='w-4/5 border-8 bg-white border-s-0'>
            <div className='flex flex-col items-center'>
              <div style={{height: '150px', width: '100%'}} className='border-b-8'>
                {payments.length === 0 ? 
                <div className='flex flex-col items-center'>
                  <span className='text-6xl font-semibold mb-3'>GHc {formatAmount(order.is_refund ? orderTotal * -1 : orderTotal)}</span>
                  <p className='text-gray-600 text-sm'>Please select a payment method</p>
                </div>:
                <>
                  <p className='flex justify-between w-full text-xl font-semibold p-2 text-gray-700'>
                    <span>Remaining: GHc {(orderTotal - paymentTotal) > 0 ? formatAmount(order.is_refund ? (orderTotal - paymentTotal) * -1 : orderTotal - paymentTotal) : 0.00.toFixed(2)}<span></span></span>
                    <span>Change: GHc <span>{(paymentTotal - orderTotal) > 0 ? formatAmount(order.is_refund ? (paymentTotal - orderTotal) *-1 : paymentTotal - orderTotal) : 0.00.toFixed(2)}</span></span>
                    
                  </p>
                  <p className='text-start w-full ps-2 font-semibold text-gray-500'>Total Due: GHc <span>{formatAmount(order.is_refund ? orderTotal * -1 : orderTotal)}</span></p>
                </>}
              </div>
              <Card className='w-full'>
                <Card.Grid className='flex flex-col items-center text-center' style={gridStyle}>
                  <Button type='text' className=' w-full h-full font-semibold text-2xl' onClick={()=>add('1')}>1</Button>
                </Card.Grid>
                <Card.Grid className='flex flex-col items-center text-center' style={gridStyle}>
                  <Button type='text' className=' w-full h-full font-semibold text-2xl' onClick={()=>add('2')}>2</Button>
                </Card.Grid>
                <Card.Grid className='flex flex-col items-center text-center' style={gridStyle}>
                  <Button type='text' className=' w-full h-full font-semibold text-2xl' onClick={()=>add('3')}>3</Button>
                </Card.Grid>
                <Card.Grid className='flex flex-col items-center text-center' style={gridStyle}>
                  <Button type='text' className=' w-full h-full font-semibold text-2xl' onClick={()=>add('10')}>+10</Button>
                </Card.Grid>
                <Card.Grid className='flex flex-col items-center text-center' style={gridStyle}>
                  <Button type='text' className=' w-full h-full font-semibold text-2xl' onClick={()=>add('4')}>4</Button>
                </Card.Grid>
                <Card.Grid className='flex flex-col items-center text-center' style={gridStyle}>
                  <Button type='text' className=' w-full h-full font-semibold text-2xl' onClick={()=>add('5')}>5</Button>
                </Card.Grid>
                <Card.Grid className='flex flex-col items-center text-center' style={gridStyle}>
                  <Button type='text' className=' w-full h-full font-semibold text-2xl' onClick={()=>add('6')}>6</Button>
                </Card.Grid>
                <Card.Grid className='flex flex-col items-center text-center' style={gridStyle}>
                  <Button type='text' className=' w-full h-full font-semibold text-2xl' onClick={()=>add('20')}>+20</Button>
                </Card.Grid>
                <Card.Grid className='flex flex-col items-center text-center' style={gridStyle}>
                  <Button type='text' className=' w-full h-full font-semibold text-2xl' onClick={()=>add('7')}>7</Button>
                </Card.Grid>
                <Card.Grid className='flex flex-col items-center text-center' style={gridStyle}>
                  <Button type='text' className=' w-full h-full font-semibold text-2xl' onClick={()=>add('8')}>8</Button>
                </Card.Grid>
                <Card.Grid className='flex flex-col items-center text-center' style={gridStyle}>
                  <Button type='text' className=' w-full h-full font-semibold text-2xl' onClick={()=>add('9')}>9</Button>
                </Card.Grid>
                <Card.Grid className='flex flex-col items-center text-center' style={gridStyle}>
                  <Button type='text' className=' w-full h-full font-semibold text-2xl' onClick={()=>add('50')}>+50</Button>
                </Card.Grid>
                <Card.Grid className='flex flex-col items-center text-center' style={gridStyle}>
                  <Button type='text' className=' w-full h-full font-semibold text-2xl'>-/+</Button>
                </Card.Grid>
                <Card.Grid className='flex flex-col items-center text-center' style={gridStyle}>
                  <Button type='text' className=' w-full h-full font-semibold text-2xl' onClick={()=>add('0')}>0</Button>
                </Card.Grid>
                <Card.Grid className='flex flex-col items-center text-center' style={gridStyle}>
                  <Button type='text' className=' w-full h-full font-semibold text-2xl' onClick={()=>add('.')}>.</Button>
                </Card.Grid>
                <Card.Grid className='flex flex-col items-center text-center' style={gridStyle}>
                  <Button type='text' className='w-full h-full font-semibold text-center' onClick={remove}><LiaBackspaceSolid size={'1.7rem'} className='w-full'/></Button>
                </Card.Grid>
              </Card>
            </div>
          </div>
          <div className='w-2/5 bg-white'>
            <div className='border'>
              <Button type='text' icon={<FaUser />} className='h-full p-3 font-semibold w-full rounded-none'>
                {order.cus_name}
              </Button>
            </div>
            <Radio.Group defaultValue={deliveryType} onChange={onChangeDeliveryType} className='w-full mt-2'>
              <Space direction='vertical' className='w-full'>
                <Radio value={'delivered'} disabled={(order.picking_state !== 'demand_sold' && order.picking_state !== 'pick_later') ? false : true } className='h-full w-full p-3 font-semibold w-full border'>Delivery</Radio>
                {!order.is_refund && <Radio value={'pick_later'} disabled={order.picking_state !== 'demand_sold' ? false : true } className='h-full w-full p-3 font-semibold w-full border'>Pick Later</Radio>}
                {/* <Radio value={'pick_demand_later'} disabled={order.picking_state !== 'pick_demand_later' ? true : false} className='h-full w-full p-3 font-semibold w-full border'>Pick Demand Later</Radio> */}
              </Space>
            </Radio.Group>
            {order.picking_state === 'pick_later' && <div className='w-full mt-2'>
              <Checkbox defaultChecked={demandSold}  onChange={onChangeDemandSold} className='h-full w-full p-3 font-semibold w-full border' >Demand Sold</Checkbox>
            </div>}
          </div>
        </div>
      </div>
    </div>
  )
}

export default PosMakPayment